<template>
  <section v-if="!hidden" class="collapsible" :class="{ open: isOpen, 'can-toggle': canToggle }">
    <div
      :class="{ open: isOpen, 'can-toggle': canToggle, filter: true, invalid: invalid }"
      @click="toggle"
      v-if="title !== 'exclusions'"
    >
      <slot name="title" :title="title">
        <span>{{ title }}</span>
        <span v-if="badge > 0" class="icon-badge">{{ badge }}</span>
      </slot>
    </div>
    <transition :name="canToggle ? 'expand' : null" @enter="enter" @after-enter="afterEnter" @leave="leave">
      <div
        v-click-outside="{ handler: toggle }"
        :class="[contentAbsolute ? 'absolute' : 'relative', 'collapsible-content']"
        v-if="isOpen"
      >
        <slot />
      </div>
    </transition>
  </section>
</template>

<script>
export default {
  name: 'collapsible',
  props: {
    title: {
      type: String,
      required: true,
    },
    badge: {
      type: Number,
      default: 0,
    },
    initialOpen: {
      type: Boolean,
      default: false,
    },
    canToggle: {
      type: Boolean,
      default: false,
    },
    hidden: Boolean,
    contentAbsolute: {
      type: Boolean,
      default: false,
    },
    invalid: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isOpen: !this.canToggle || this.initialOpen,
    };
  },
  methods: {
    toggle() {
      if (this.canToggle) {
        this.isOpen = !this.isOpen;
        this.$emit('toggle', this.isOpen);
      }
    },
    enter(el) {
      el.style.position = 'absolute';
      el.style.visibility = 'hidden';
      el.style.height = 'auto';
      el.style.border = '1px solid #898c8d';

      const { height } = getComputedStyle(el);
      el.style.position = 'relative';
      el.style.visibility = 'visible';
      el.style.height = 0;

      getComputedStyle(el); // Force repaint

      setTimeout(() => {
        el.style.height = height;
      });
    },
    afterEnter(el) {
      el.style.height = 'auto';
    },
    leave(el) {
      const { height } = getComputedStyle(el);
      el.style.height = height;

      getComputedStyle(el); // Force repaint

      setTimeout(() => {
        el.style.height = 0;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
h3 {
  font-size: 21px;
  font-weight: normal;
  text-transform: uppercase;
  display: block;
  margin: 0;
  padding: 30px 20px 20px 0;
  position: relative;
  z-index: 2;

  @include bp-lg-laptop {
    padding-left: 35px;
  }
  span {
    vertical-align: middle;
  }
  .icon-badge {
    margin-left: 5px;
    vertical-align: middle;

    @include bp-lg-laptop {
      margin-left: 10px;
    }
  }
}
.collapsible {
  padding-right: 10px;
  position: relative;
  .filter {
    text-align: left;
    height: 40px !important;
    padding: 0 0 0 15px !important;
    cursor: pointer;
    color: $primary-black;
    background: $primary-white;
    display: flex;
    align-items: center;
    border: 1px solid #898c8d;
    padding: 7px 55px 9px 15px;
    height: auto;
    width: 130px;
    justify-content: space-between;

    &::after {
      content: '';
      background-image: url('../assets/icons/carrot_down.svg?external');
      background-repeat: no-repeat;
      background-size: 16px 8px;
      width: 16px;
      height: 8px;
      transition: transform 100ms;
      margin: 10px;
    }
    &.open::after {
      transform: rotate(180deg);
    }
    span {
      vertical-align: middle;
    }
    .icon-badge {
      margin-left: 5px;
      vertical-align: middle;
      font-size: 14px;
      background: $primary !important;
      color: $primary-white !important;
      &.hidden {
        visibility: hidden;
      }

      @include bp-lg-laptop {
        margin-left: 10px;
      }
    }
    &.invalid {
      border: 1px solid red;
    }
  }
}
.collapsible-content {
  &.absolute {
    position: absolute !important;
    z-index: 4;
    border: none !important;
  }
  &.relative {
    position: relative;
  }
  margin: 0;
  display: flex;
  justify-content: space-between;

  // z-index: 2;
}
.can-toggle {
  h3::after {
    content: '';
    background-image: url('../assets/icons/carrot_up.svg?external');
    background-repeat: no-repeat;
    position: absolute;
    top: calc(50% + 5px);
    right: 35px;
    width: 20px;
    height: 12px;
    transform: translateY(-50%);
    transition: transform 300ms;
  }
  &.open {
    h3::after {
      transform: rotate(180deg) translateY(50%);
    }
  }
}
.expand {
  &-enter-active,
  &-leave-active {
    transition: height 300ms;
    overflow: hidden;
  }
  &-enter,
  &-leave-to {
    height: 0;
  }
}
</style>
